export function WholeNumber(e: string) {
  const value = Number(e);
  return (
    !isNaN(value) &&
    (function (x) {
      return (x | 0) === x;
    })(parseFloat(String(value)))
  );
}
